import { InputLabel, MenuItem, Select } from '@mui/material';
import { style } from 'constant/constants';
import { jsonData } from 'constant/jsonData';
import { useState } from 'react';
import ConditionalInputs from './ConditionalInputs';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { imgsData } from 'utils/imageData';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedImage, setSelectedKey } from 'reduxStore/bracketOptionsSlice';
import { inputFeildsObj } from './BracketCalcHelper';

// meta inputs represent input data for inputs to be created, it includes,
// name and lable of input only
const createMetaInputs = (labels) => {
  let metaInputs = [];
  labels.map((label) => {
    metaInputs.push({
      label: label,
      name: inputFeildsObj[label].name
    });
  });
  return metaInputs;
};

// renders options of the dropdown
const renderOptions = (levelData) => {
  let options = [];
  let optionNames = [];
  let metaInputsArr = [];

  for (let key in levelData) {
    if (key !== 'label') {
      const subKeys = key.split('|');
      // for the last key creat meta inputs array
      if (levelData[key] === 'end') {
        metaInputsArr = createMetaInputs(subKeys);
        break;
      }
      // adding keys into iptions if they are connected in a signle string with |
      if (subKeys?.length > 1) {
        for (let subKey of subKeys) {
          // console.log('subkey', subKey);
          optionNames.push(subKey);
          options.push(
            <MenuItem value={subKey} key={subKey} sx={{ fontFamily: style.fontFamily }}>
              {subKey}
            </MenuItem>
          );
        }
        continue;
      } else {
        optionNames.push(key);
        options.push(
          <MenuItem value={key} key={key} sx={{ fontFamily: style.fontFamily }}>
            {key}
          </MenuItem>
        );
      }
    }
  }
  return { options, metaInputsArr, optionNames };
};

const ConditionalDropdowns = ({
  setCurrentOptions,
  setDrawGraph,
  isEditMode,
  setSnowLoadImage,
  setIsCalcInEditMode
}) => {
  let inputsList = [];
  const { selectedKey } = useSelector((store) => store.bracketOptions);
  const { readOnly } = useSelector((store) => store.auth);
  const dispatch = useDispatch();
  const [firstOptions, setFirstOptions] = useState(new Map());
  const [clearInputs, setCearInputs] = useState(false);

  // level is key
  const handleChange = (level, tempData, event) => {
    setSnowLoadImage(false);
    setCearInputs(false);
    isEditMode && setIsCalcInEditMode(false);
    dispatch(
      setSelectedKey({ level, data: tempData, value: event.target.value, name: event.target.name })
    );
    const selectedImage = imgsData.find((image) => image.title == event.target.value);
    dispatch(setSelectedImage({ imgData: selectedImage }));
    setCearInputs(true);
  };

  const renderSubDropdown = (data, key) => {
    if (!data) {
      return null;
    }
    // necessory but don't know r8 now
    const subData = data;

    if (!subData || typeof subData !== 'object') {
      return null;
    }

    inputsList = [];
    if (subData.label === 'End') {
      inputsList = renderOptions(subData).metaInputsArr;
      return null;
    }

    return (
      <>
        <InputLabel
          htmlFor="demo-simple-select-label"
          sx={{
            fontFamily: style.fontFamily,
            color: style.LIGHT.primary,
            mt: 2
          }}
          className="text-menu-color-green">
          {subData.label}
        </InputLabel>
        <Select
          disabled={readOnly}
          value={selectedKey?.get(key)?.value ? selectedKey?.get(key)?.value : null}
          size="small"
          sx={{ width: '100%', fontFamily: style.fontFamily, mt: 0, mb: -2 }}
          name={subData.label}
          onChange={(e) => {
            handleChange(key, data, e);
          }}>
          {renderOptions(subData).options}
        </Select>
      </>
    );
  };

  // this is to render dropdown after first one
  const html = [];

  selectedKey?.forEach((obj, key) => {
    html.push(renderSubDropdown(obj?.object, key + 1));
  });

  const handleRenderOptions = (data) => {
    const { options, optionNames } = renderOptions(data);
    const imgs = imgsData.filter((item) => optionNames.includes(item.tag));
    setCurrentOptions(imgs);
    return options;
  };

  useEffect(() => {
    if (selectedKey.size === 0) {
      setFirstOptions(handleRenderOptions(jsonData));
    } else {
      const lastKey = [...selectedKey.keys()].pop();
      if (selectedKey.has(lastKey) && selectedKey.get(lastKey) !== undefined) {
        const nestedObject = selectedKey.get(lastKey).object; // Access the nested object
        const objectKeys = Object.keys(nestedObject); // Get keys of the nested object
        const newOptions = objectKeys.flatMap((key) => key.split('|'));
        const imgs = imgsData.filter((item) => newOptions.includes(item.tag));
        setCurrentOptions(imgs);
      }
    }
  }, [selectedKey]);

  // dont dhow graph when no iputs are available
  useEffect(() => {
    inputsList?.length < 1 && setDrawGraph(false);
  }, [inputsList]);

  return (
    <>
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary
        }}
        className="text-menu-color-green">
        Roof Type
      </InputLabel>
      <Select
        disabled={readOnly}
        value={selectedKey?.get(0)?.value ? selectedKey?.get(0)?.value : null}
        size="small"
        sx={{ width: '100%', fontFamily: style.fontFamily, mt: 0, mb: -2 }}
        name="Roof Type"
        onChange={(e) => {
          handleChange(0, jsonData, e);
        }}>
        {firstOptions || null}
      </Select>
      {html}
      {inputsList?.length > 0 && (
        <ConditionalInputs
          isEditMode={isEditMode}
          clearInputs={clearInputs}
          dropDownValues={selectedKey}
          metaInputsList={inputsList}
          setDrawGraph={setDrawGraph}
          setSnowLoadImage={setSnowLoadImage}
        />
      )}
    </>
  );
};

ConditionalDropdowns.propTypes = {
  setCurrentOptions: PropTypes.func,
  setDrawGraph: PropTypes.func,
  isEditMode: PropTypes.func,
  setSnowLoadImage: PropTypes.func,
  setIsCalcInEditMode: PropTypes.func
};

export default ConditionalDropdowns;
